/**
 * TwoColumnLayout Component
 * 
 * A responsive two-column layout component that:
 * - Displays children in two columns
 * - Automatically wraps additional children to new rows
 * - Supports customizable gap between columns and rows via CSS variable
 * - Uses CSS Grid for layout
 * - Supports customizable column width ratios via --flex-left and --flex-right variables
 * 
 * Usage:
 * <two-column-layout>
 *   <div>Column 1</div>
 *   <div>Column 2</div>
 *   <div>Wraps to new row</div>
 * </two-column-layout>
 * 
 * Customization:
 * two-column-layout {
 *   --gap: 1rem;           /* Gap between columns and rows 
 *   --flex-left: 1;        /* Width ratio for left column 
 *   --flex-right: 1;       /* Width ratio for right column 
 * }
 */

import styleText from './two-column.css?raw';

export class TwoColumns extends HTMLElement {
  private static readonly sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();

  constructor() {
    super();
    
    // Create shadow DOM for encapsulation
    const shadow = this.attachShadow({ mode: 'open' });
    shadow.adoptedStyleSheets = [
      ...shadow.adoptedStyleSheets,
      TwoColumns.sheet
    ];
    
    // Define the template with both HTML and CSS
    const template = `
      <div class="grid-container">
        <slot></slot>
      </div>
    `;

    shadow.innerHTML = template;
  }
}

// Check if the element is already defined before registering it
if (!customElements.get('two-columns')) {
  customElements.define('two-columns', TwoColumns);
} else {
  console.warn("two-columns already defined");
}
